/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_End_LeadInputs */

const en_us2_workout_swap_end_lead = /** @type {(inputs: Workout_Swap_End_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One question, at the end, not mid-set.`)
};

const pt_br2_workout_swap_end_lead = /** @type {(inputs: Workout_Swap_End_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma pergunta só, no fim, e não no meio da série.`)
};

const es_419_workout_swap_end_lead = /** @type {(inputs: Workout_Swap_End_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una sola pregunta, al final y no en medio de la serie.`)
};

const pt_pt2_workout_swap_end_lead = /** @type {(inputs: Workout_Swap_End_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma só pergunta, no fim, e não a meio da série.`)
};

const fr_fr2_workout_swap_end_lead = /** @type {(inputs: Workout_Swap_End_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une seule question, à la fin, pas en pleine série.`)
};

const de_de2_workout_swap_end_lead = /** @type {(inputs: Workout_Swap_End_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Frage, am Ende, nicht mitten im Satz.`)
};

const it_it2_workout_swap_end_lead = /** @type {(inputs: Workout_Swap_End_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una sola domanda, alla fine, non a metà serie.`)
};

/**
* | output |
* | --- |
* | "One question, at the end, not mid-set." |
*
* @param {Workout_Swap_End_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_end_lead = /** @type {((inputs?: Workout_Swap_End_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_End_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_end_lead(inputs)
	if (locale === "es-419") return es_419_workout_swap_end_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_end_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_end_lead(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_end_lead(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_end_lead(inputs)
	return en_us2_workout_swap_end_lead(inputs)
});
export { workout_swap_end_lead as "workout-swap.end_lead" }